'use client'

import { useEffect, useRef } from 'react'

/**
 * Envia o caminho actual para `/api/public/not-found-hit` (registo de 404).
 * Falhas são ignoradas (não afecta a página vista pelo visitante).
 */
export function NotFoundReporter(): null {
  const sent = useRef(false)

  useEffect(() => {
    if (sent.current) return
    sent.current = true
    if (typeof window === 'undefined') return
    const path = window.location.pathname || ''
    if (!path) return

    void fetch('/api/public/not-found-hit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path }),
      keepalive: true,
    }).catch(() => {})
  }, [])

  return null
}
